import {ArrowLeft, HelpCircle} from 'lucide-react'
import { Link } from 'react-router-dom'
import Layout from '@/components/Layout'
import SeoHead from '@/components/SeoHead'

function NotFound() {
  return (
    <Layout>
      <SeoHead
        title="Page Not Found"
        description="This Penguin Pad page could not be found."
      />
      <div className="mx-auto flex max-w-lg flex-col items-center px-4 py-24 text-center sm:px-6">
        <div className="flex h-14 w-14 items-center justify-center rounded-full border border-white/10 bg-white/[0.03] text-zinc-500">
          <HelpCircle className="h-6 w-6" aria-hidden="true" />
        </div>
        <h1 className="mt-4 text-xl font-bold text-white">Page not found</h1>
        <p className="mt-2 text-sm text-zinc-400">
          The page you are looking for does not exist or has been moved.
        </p>
        <div className="mt-6 flex flex-col gap-2 sm:flex-row">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-1.5 rounded-full bg-lime-400 px-4 py-2 text-sm font-semibold text-black"
          >
            <ArrowLeft className="h-4 w-4" aria-hidden="true" />
            Back home
          </Link>
          <Link
            to="/how-it-works"
            className="inline-flex items-center justify-center rounded-full border border-white/10 px-4 py-2 text-sm font-medium text-white hover:border-white/20"
          >
            How it works
          </Link>
        </div>
      </div>
    </Layout>
  )
}

export default NotFound
